import React from "react";
import { Field } from "formik";
import Tooltip from "@mui/material/Tooltip";
import WarningIcon from "@mui/icons-material/Warning";
import { pink } from "@mui/material/colors";

const TableLabSelectField = ({
  childOpt,
  pageId,
  schemaItem,
  option = [],
  error = {},
  id,
  tdkeys,
  rowkeys,
  tableName,
  name,
  errorBorder,
  csvUplaodEnabled,
  disabled,
}) => {
  let optionsData = option;

  if (
    childOpt &&
    childOpt.childPageId === pageId &&
    childOpt.childItemId === schemaItem
  ) {
    optionsData = childOpt.optionsData;
  }

  return (
    <div className="wrapper">
      <div className="form-field">
        <Field
          as="select"
          className={`tableInput ${errorBorder}`}
          id={id + tdkeys + 1}
          rowkeys={tdkeys}
          tdkeys={rowkeys}
          name={`${tableName}[${tdkeys}].${name}`}
          disabled={csvUplaodEnabled || disabled}
          data-testid="TableLabSelectField"
        >
          <option value=""></option>
          {optionsData.map((i, index) => (
            <option key={index} value={i.value?.split("[")[0]}>
              {i.value}
            </option>
          ))}
        </Field>
        {error?.[name] && (
          <span className="icon">
            <Tooltip title={error[name]}>
              <WarningIcon sx={{ color: pink[500] }} />
            </Tooltip>
          </span>
        )}
      </div>
    </div>
  );
};

export default TableLabSelectField;
